import { notification } from 'antd';

/**
 * Opens a notification with the specified type, title, and description
 * @param {string} placement - Position of the notification (e.g., 'topLeft', 'topRight', 'bottomLeft', 'bottomRight')
 * @param {string} title - Title of the notification
 * @param {string} description - Description/message of the notification
 * @param {string} type - Type of notification: 'info', 'warning', 'error', 'success' (default: 'info')
 */
const openNotification = (placement, title, description, type = 'info') => {
  switch (type) {
    case 'warning':
      notification.warning({
        message: title,
        description,
        placement,
      });
      break;
    case 'error':
      notification.error({
        message: title,
        description,
        placement,
      });
      break;
    case 'success':
      notification.success({
        message: title,
        description,
        placement,
      });
      break;
    case 'info':
    default:
      notification.info({
        message: title,
        description,
        placement,
      });
      break;
  }
};

export default openNotification;
